/**
 * 파일명 : ProjectBoard.jsx
 * 설명 : 사업실적 게시판
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.0       2023-03-28   황은택     최초작성
 * 1.1       2024-07-02   기라성     이미지파일 왜곡없이 보여지도록 수정
 */

/************************************************
 * Import 영역  
 ************************************************/
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import "../css/projectBoard.css";
import * as imageUtil from "../utils/imageUtil";

function ProjectBoard({ProjectBoard:{id, instCd, pjCd, pjNm, pjCntnt, lstChgEmpNm, lstChgDtm, imgUrl, fileNm, fileContent, filePath}, page}) {

    const pageId = page;
    const [imageUrl, setImageUrl] = useState(null);

    useEffect(() => {
        setImageUrl(imageUtil.fn_getImageUrl(fileContent))
    }, []);

    pjCntnt = pjCntnt.replace(/<br\/>/ig, "\n");
    pjCntnt = pjCntnt.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/ig, "");

    // "Mobi" 가 User agent에 포함되어 있으면 모바일
    const isMobile = /Mobi/i.test(window.navigator.userAgent);

    return (
        <div>
            <>
            {!isMobile ? 
                // 웹
                <div className="projectBoard_W">
                    <tr key={id}>
                        <th colspan="2"></th>
                    </tr>
                    <tr>
                        <td className="projectBoardMain">
                            <td className="boardLeft">
                                <div className="boardThumb">
                                    <Link to = {pageId}
                                            state = {{
                                                        id : id
                                                        , instCd : instCd
                                                        , pjCd : pjCd
                                                    }}>
                                        <img src={imageUrl} style={{objectFit: "contain"}} />
                                    </Link>
                                </div>
                            </td>
                            <td className="boardRight">
                                <div className="boardCon">
                                    <div className="boardRightTitle">
                                        <Link to = {pageId}
                                                    state = {{
                                                            id : id
                                                            , instCd : instCd
                                                            , pjCd : pjCd
                                                            }}>
                                                   {pjNm}
                                        </Link>
                                    </div>
                                    <div className="boardRightContents">
                                        <Link to = {pageId}
                                                state = {{
                                                        id : id
                                                        , instCd : instCd
                                                        , pjCd : pjCd
                                                        }}>
                                                   {pjCntnt}
                                        </Link>
                                    </div>
                                    <div className="boardRightWriter">
                                        {lstChgEmpNm}<font>&nbsp;&nbsp;|&nbsp;&nbsp;</font>
                                        {lstChgDtm}
                                    </div>
                                </div>
                            </td>
                        </td>
                    </tr>
                </div>
            :
                // 모바일
                <div className="projectBoard_M">
                    <tr key={id}>
                        <th colspan="2"></th>
                    </tr>
                    <tr>
                        <td className="projectBoardMain">
                            <tr>
                                <td className="boardLeft">
                                    <div className="boardThumb">
                                        <Link to = {pageId}
                                                state = {{
                                                            id : id
                                                            , instCd : instCd
                                                            , pjCd : pjCd
                                                        }}>
                                            <img src={imageUrl} style={{objectFit: "contain"}}/>
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="boardRight">
                                    <div className="boardCon">
                                        <div className="boardRightTitle">
                                            <Link to = {pageId}
                                                        state = {{
                                                                id : id
                                                                , instCd : instCd
                                                                , pjCd : pjCd
                                                                }}>
                                                       {pjNm}
                                            </Link>
                                        </div>
                                        <div className="boardRightContents">
                                            <Link to = {pageId}
                                                    state = {{
                                                            id : id
                                                            , instCd : instCd
                                                            , pjCd : pjCd
                                                            }}>
                                                       {pjCntnt}
                                            </Link>
                                        </div>
                                        <div className="boardRightWriter">
                                            {lstChgEmpNm}<font>&nbsp;&nbsp;|&nbsp;&nbsp;</font>
                                            {lstChgDtm}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </td>
                    </tr>
                </div>
            }
            </>
        </div>
    )
}
export default ProjectBoard;
